import { Alert, Grid } from "@mui/material";
import { useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getDateStringNormalized } from "../../_helpers/dateTime.helper";
import { UserProfileProfileImageView } from "./userProfile-profileImageView";
import { PdfExporter } from "../../_components/pdfExporter/pdfExporter";
import { accountService } from "../../_services/accounts.service";
const logoImg = require('../../_assets/images/Logo-Standard.png');
const fiaImg = require('../../_assets/images/fia.png');

var QRCode = require('qrcode')

export function UserProfileOfficialLicensePdf(params: {
    data: any
}) {

    const { userId } = useParams<{ userId: string }>();
    let navigate = useNavigate();

    const targetRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        var url = window.location.host + "/Licence/" + params.data.token;
        QRCode.toCanvas(document.getElementById('licenseId'), url, {
            margin: 1,
        }, (error: any) => {
            if (error) console.error(error)
        })
    }, []);

    return (
        <>
            <div ref={targetRef} style={{ padding: 5, backgroundColor: "#f5f5f5" }}>
                <Grid container>

                    <Grid item xs={12} style={{ marginBottom: "10px" }}>
                        {params.data.statusString == "Active" ?
                            <Alert severity="success" >Active Licence Expiring: {getDateStringNormalized(params.data.licenseExpirationDate)}</Alert> :
                            params.data.statusString == "Inactive" ?
                                <Alert severity="error" >{params.data.statusString} Licence Expired: {getDateStringNormalized(params.data.licenseExpirationDate)}</Alert>
                                : <Alert severity="error" >{params.data.statusString} Licence</Alert>
                        }
                    </Grid>

                    <Grid item xs={6}>
                        <Grid container>
                            <Grid item xs={9}>
                                <img style={{
                                    height: "40px",
                                    marginTop: "10px",
                                    display: 'block',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                    marginBottom: "10px",
                                    float: "left"
                                }} src={logoImg} alt={"test"}></img>
                            </Grid>

                            <Grid item xs={3}>
                                <img style={{
                                    height: "40px",
                                    marginTop: "10px",
                                    display: 'block',
                                    float: "right"
                                }} src={fiaImg} alt={"test"}></img>
                            </Grid>

                            <Grid item xs={12} style={{ "textAlign": "center", "marginTop": "20px" }}>
                                <strong>FIA OFFICIAL LICENCE</strong>
                            </Grid>
                            <Grid item xs={12} style={{ marginTop: "10px" }}>
                                <strong>Name:</strong>
                            </Grid>
                            <Grid item xs={12}>
                                {params.data.userName}
                            </Grid>

                            <Grid item xs={12} style={{ marginTop: "10px" }}>
                                <strong>Grade</strong>
                            </Grid>

                            {(params.data.licenseNames && params.data.licenseNames.length > 0) && params.data.licenseNames.map((_d: any) =>
                                <Grid item xs={12} style={{ marginBottom: "10px" }}>
                                    {_d}
                                </Grid>
                            )}
                            {(!params.data.licenseNames || params.data.licenseNames.length < 1) &&
                                <Grid item xs={12} style={{ marginBottom: "10px" }}>
                                    -
                                </Grid>
                            }

                        </Grid>


                    </Grid>


                    <Grid item xs={6}>
                        <Grid container>

                            <Grid item xs={12}>
                                <UserProfileProfileImageView userId={params.data.userId} />
                            </Grid>

                            < Grid item xs={12}>
                                <strong>Date of Birth:</strong>
                            </Grid>
                            <Grid item xs={12} style={{ marginBottom: "10px" }}>
                                {getDateStringNormalized(params.data.dateOfBirth)}
                            </Grid>
                            <Grid item xs={12}>
                                <strong>Medical:</strong>
                            </Grid>
                            <Grid item xs={12} style={{ marginBottom: "10px" }}>
                                {params.data.medicalExpiry ? getDateStringNormalized(params.data.medicalExpiry) : '-'}
                            </Grid>
                            <Grid item xs={12}>
                                <strong>Expiry:</strong>
                            </Grid>
                            <Grid item xs={12} style={{ marginBottom: "10px" }}>
                                {getDateStringNormalized(params.data.licenseExpirationDate)}
                            </Grid>
                            <Grid item xs={12}>
                                <strong>Garda Vetting:</strong>
                            </Grid>
                            <Grid item xs={12} style={{ marginBottom: "10px" }}>
                                {params.data.gardaVettingExpiry ? getDateStringNormalized(params.data.gardaVettingExpiry) : '-'}
                            </Grid>
                            <Grid item xs={12}>
                                <strong>Licence No:</strong>
                            </Grid>
                            <Grid item xs={12} style={{ marginBottom: "10px" }}>
                                {params.data.licenseNumber}
                            </Grid>

                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <canvas id="licenseId" style={{ marginLeft: "calc(50% - 134px)", display: "block", float: "left" }}></canvas>
                    </Grid>
                </Grid>
            </div >
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <PdfExporter targetRef={targetRef} licenseNumber={params.data.licenseNumber} />
                </Grid>
            </Grid>
        </>
    );
}